<template>
  <div>
    <Dialog :visible.sync="exibirModalNovo" header="Feriado" :modal="true" :style="{width: '480px'}" @hide="fecharModal">
        <div class="p-formgroup-inline">
            <div class="p-field-radiobutton">
                <RadioButton name="excluirFeriado" value="NAO_EXCLUIR_FERIADO" v-model="excluirFeriado" />
                <label>É Feriado</label>
            </div>
            <div class="p-field-radiobutton">
                <RadioButton name="excluirFeriado" value="EXCLUIR_FERIADO" v-model="excluirFeriado" />
                <label>Não é Feriado</label>
            </div>
        </div>    
        <div v-if="exibirAviso" class="p-field p-col-12 p-md-12">
            <Message severity="warn" :sticky="true" :closable="false">{{ aviso }}</Message>
        </div>
        <div>
           <p>
              <span class="p-text-bold">É Feriado</span>: Mantém esse dia como feriado.<br/>
              <span class="p-text-bold">Não é Feriado</span>: Ignora o feriado e aplica as regras de um dia normal.
            </p>
        </div>
        <h6 class="p-text-bold">Marcações do dia {{ dataPonto }}</h6>	     				
        <template #footer>
            <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
            <Button label="Salvar" icon="pi pi-check" @click="salvar" />
        </template>        
    </Dialog>
  </div>
</template>

<script>
import ControlePontoService from '@/service/ControlePontoService';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
    controlePontoService: null,
    props: {
        callback: Function,
    },
    data() {
        return {
            exibirAviso: false,
            aviso: 'Não existe feriado cadastrado para essa data',
            excluirFeriado: 'NAO_EXCLUIR_FERIADO',
            dataPonto: null,
            exibirModalNovo: false,
            requisicao: {},
            feriadoExcluido: {id: null, excluido: false, data: new Date()},
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        processar(req) {   
            this.dataPonto = this.formatarStringData(req.dataPonto);
            this.requisicao = {...req};  
            this.controlePontoService.buscarFeriadoExcluido(req)
            .then(resp => {
                if(resp.data.feriados.length == 0) {
                    this.exibirAviso = true;
                } 
                this.feriadoExcluido = resp.data.feriadoExcluido;
                if(this.feriadoExcluido.excluido) {
                    this.excluirFeriado = 'EXCLUIR_FERIADO';
                }                   
                this.exibirModalNovo = true;                  
            }).catch(erro => {exibirMensagem(this, erro)});            
        },
        salvar() {   
            this.feriadoExcluido.excluido = false;
            if(this.excluirFeriado == 'EXCLUIR_FERIADO') {
                this.feriadoExcluido.excluido = true;
            }
            this.feriadoExcluido.data = this.formatarData(this.dataPonto);
            this.requisicao['feriadoExcluido'] = this.feriadoExcluido;                
            this.controlePontoService.salvarFeriadoExcluido(this.requisicao)
            .then(resp => {
                exibirMensagem(this, resp);		
                this.callback(this.formatarData(this.dataPonto), this.formatarData(this.dataPonto));
                this.fecharModal();                
            })
            .catch(erro => {
                console.log(erro);                
                exibirMensagem(this, erro)
            });
        },  
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},      
        formatarStringData(data) {
            if(!data || data instanceof Date) {
                return '';
            } 
            let partes = data.split('-');
            return partes[2] + '/' + partes[1] + '/' + partes[0];
        }, 
        fecharModal() {
            this.exibirAviso = false;
            this.exibirModalNovo = null;
            this.feriadoExcluido = {id: null, excluido: false, data: new Date()};  
        }
    },
    created() {
        this.controlePontoService = new ControlePontoService();
    },
}
</script>

<style>

</style>